var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "row" }, [
    _c(
      "div",
      {
        staticClass:
          "container-fluid bg-accent d-flex flex-column align-items-center justify-content-center px-32 px-lg-12 text-center"
      },
      [
        _c("h2", { staticClass: "text-white " }, [_vm._v(_vm._s(_vm.title))]),
        _vm._v(" "),
        _vm.cta_repeater
          ? _c(
              "div",
              { staticClass: "mt-32" },
              [
                _vm._l(_vm.cta_repeater, function(cta) {
                  return [
                    _c(
                      "a",
                      {
                        staticClass: "mr-sm-16 mb-16 mb-sm-0",
                        class: cta.button_style,
                        attrs: { href: cta.repeated_cta_link }
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(cta.repeated_cta_label) +
                            "\n                "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("br", { staticClass: "d-sm-none" })
                  ]
                })
              ],
              2
            )
          : _vm._e()
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }